import React from "react";
import {
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  Button,
} from "reactstrap";

const PresentationNavbar = (props) => {
  return (
    <>
      <Navbar
        className="navbar-light bg-white mb-4"
        expand="lg"
        style={{ zIndex: 10 }}
      >
        <Container>
          <NavbarBrand onClick={() => {}} style={{ textTransform: "none" }}>
            {props.reportName}
          </NavbarBrand>
          <Nav className="ml-auto" navbar>
            <Button
              color="primary"
              onClick={() => alert("Coming Soon!")}
              size="md"
            >
              Download PDF
            </Button>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default PresentationNavbar;
